//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PopupAgreementsCookies',

  emits: [
    'closeCookieModal'
  ],

  methods: {
    agreementWithCookies() {
      this.$cookies.set('cookies_accepted', 'true', {
        path: '/',
        maxAge: 60 * 60 * 24,
        // domain: '.linza.ru',
        })
      this.$emit('closeCookieModal')
    },
  },
}
